<template>
  <div class="excel-edit-editor" v-if="vm.MAMDetails">
    <div class="info-language-section">
      <div class="language-selection">
        <label> {{ $t("excelEdit.language") }} </label>
        <dropdown
          id="language-dd"
          v-model="vm.selectedLanguage"
          :items="languageList"
          textField="name"
          valueField="key"
          data-cy="excel-edit-data-languages-ddn">
          <template #item-template="{ entry }">
            <span v-if="entry"> {{ entry.name }} </span>
          </template>
        </dropdown>
      </div>
      <div class="info-area">
        <!--  <div class="info-line articles">
          <div class="count">
            {{ articleCountLocalized }}
            </div>
          <div class="icon"><i class="mdp-Article" /></div>
        </div>
        <div class="info-line variation-groups">
          <div class="count">
            {{ varGroupsCountLocalized }}
            </div>
          <div class="icon"><i class="mdp-VariantGroups" /></div>
        </div> -->
      </div>
    </div>
    <div class="attribute-group-section" v-if="hasMultipleAttributeGroups">
      <div class="attribute-group">
        <label> {{ $t("attributeGroup") }} </label>
        <dropdown
          :items="vm.attributeGroups"
          text-field="attributeGroupPath"
          value-field="attributeGroupId"
          :default="`<${$t('none')}>`"
          v-model="vm.selectedAttributeGroup"
          data-cy="excel-edit-attribute-groups-ddn">
        </dropdown>
      </div>
      <div class="hint">
        <div class="icon">
          <i class="mdp-Info"></i>
        </div>
        <div class="text">
          {{ $t("excelEdit.multipleAttributegroupsHint") }}
        </div>
      </div>
    </div>
    <div class="export-selection-section">
      <strong class="mb-1"> {{ $t("excelEdit.exportSelectionSectionTitle") }} </strong>
      <div class="export-selection-section-content">
        <div class="selection-area">
          <div class="general">
            <BFormCheckbox v-model="vm.exportSelection.masterData.selected" data-cy="excel-edit-master-data-cbx">
              {{ $t("excelEdit.masterData") }}
            </BFormCheckbox>
            <BFormCheckbox v-model="vm.exportSelection.alternativeArticleNo.selected" data-cy="excel-edit-alternative-artno-cbx">
              {{ $t("excelEdit.alternativeArticleNo") }}
            </BFormCheckbox>
            <BFormCheckbox v-model="vm.exportSelection.mediaAssets.selected" data-cy="excel-edit-media-asset-cbx">
              {{ $t("excelEdit.mediaAssets") }}
            </BFormCheckbox>
            <BFormCheckbox v-model="vm.exportSelection.keywords.selected" data-cy="excel-edit-keywords-cbx"> {{ $t("excelEdit.keywords") }} </BFormCheckbox>
            <BFormCheckbox v-model="vm.exportSelection.classification.selected" data-cy="excel-edit-classification-cbx">
              {{ $t("excelEdit.classification") }}
            </BFormCheckbox>
            <BFormCheckbox v-model="vm.exportSelection.gpsr.selected" data-cy="excel-edit-gpsr-cbx"> {{ $t("excelEdit.gpsr") }} </BFormCheckbox>
            <BFormCheckbox
              v-model="vm.exportSelection.references.selected"
              :disabled="exportSelectionPermissions && !exportSelectionPermissions[vm.exportSelection.references.name]"
              data-cy="excel-edit-references-cbx">
              <span
                v-tooltip="
                  exportSelectionPermissions && !exportSelectionPermissions[vm.exportSelection.references.name] && $t('excelEdit.referenceattributesFound')
                ">
                {{ $t("excelEdit.references") }}
              </span>
            </BFormCheckbox>

            <BFormCheckbox
              v-model="vm.exportSelection.prices.selected"
              :disabled="exportSelectionPermissions && !exportSelectionPermissions[vm.exportSelection.prices.name]"
              data-cy="excel-edit-prices-cbx">
              {{ $t("excelEdit.prices") }}
            </BFormCheckbox>
          </div>
          <div class="attributes">
            <BFormCheckbox v-model="vm.exportSelection.globalAttributes.selected" data-cy="excel-edit-global-attributes-cbx">
              {{ $t("excelEdit.globalAttributes") }}
            </BFormCheckbox>
            <BFormCheckbox v-model="vm.exportSelection.erpAttributes.selected" data-cy="excel-edit-erp-attributes-cbx">
              {{ $t("excelEdit.erpAttributes") }}
            </BFormCheckbox>
            <BFormCheckbox
              v-model="vm.exportSelection.textAttributes.selected"
              :disabled="hasMultipleAttributeGroups && !vm.selectedAttributeGroup"
              data-cy="excel-edit-text-attributes-cbx">
              <span> {{ $t("excelEdit.textAttributes") }} </span>
            </BFormCheckbox>
            <BFormCheckbox
              v-model="vm.exportSelection.tableAttributes.selected"
              :disabled="hasMultipleAttributeGroups && !vm.selectedAttributeGroup"
              data-cy="excel-edit-table-attributes-cbx">
              <span>
                {{ $t("excelEdit.tableAttributes") }}
              </span>
            </BFormCheckbox>
            <div class="row-filler"></div>
            <BFormCheckbox v-model="vm.includeUnits" data-cy="excel-edit-include-units-cbx" :disabled="!isIncludeUnitsEnabled">
              {{ $t("excelEdit.includeUnits") }}
            </BFormCheckbox>
          </div>
        </div>
        <div class="filler-area"></div>
      </div>
    </div>
    <div class="mam-section-selection" v-if="vm.exportSelection.mediaAssets.selected && vm.MAMDetails?.isMamEnabled">
      <div class="mam-section-selection-content">
        <label> {{ $t("mamSections") }} </label>
        <BDropdown class="dropdown-default" :text="selectedMAMSectionString" auto-close="inside" data-cy="excel-edit-mam-sections-cbx">
          <BDropdownItem class="mam-section-selection-entry" @click="deselectAllMamSection" v-if="allMAMSectionsSelected">
            {{ $t("deselectAll") }}
          </BDropdownItem>
          <BDropdownItem class="mam-section-selection-entry" @click="selectAllMamSection" v-else> {{ $t("selectAll") }} </BDropdownItem>
          <BDropdownForm form-class="p-0">
            <div class="mam-section-selection-entry hover px-3 py-1" v-for="(section, index) in mamSectionSelectionList" :key="index">
              <b-form-checkbox v-model="section.selection"> {{ $t(`mamSection.${section.name}`) }} </b-form-checkbox>
            </div>
          </BDropdownForm>
        </BDropdown>
      </div>
    </div>
    <div class="erp-section-selection" v-if="vm.exportSelection.erpAttributes.selected">
      <div class="erp-section-selection-content">
        <label> {{ $t("erpSections") }} </label>
        <b-dropdown class="dropdown-default" :text="selectedERPSectionString" data-cy="excel-edit-erp-section-cbx">
          <BDropdownItem class="erp-section-selection-entry" @click="deselectAllErpSection" v-if="allERPSectionsSelected">
            {{ $t("deselectAll") }}
          </BDropdownItem>
          <BDropdownItem class="erp-section-selection-entry" @click="selectAllErpSection" v-else> {{ $t("selectAll") }} </BDropdownItem>
          <BDropdownForm form-class="p-0">
            <div class="erp-section-selection-entry hover px-3 py-1" v-for="(section, index) in erpSectionSelectionList" :key="index">
              <b-form-checkbox v-model="section.selection" :disabled="!section.isSelectable"> {{ section.name }} </b-form-checkbox>
            </div>
          </BDropdownForm>
        </b-dropdown>
      </div>
    </div>
    <div class="action-result-section">
      <Alert
        class="w-100"
        :show="exportWarningsKeys.length < 1 && vm.showExportSuccessAlert"
        dismissible
        @dismissed="vm.showExportSuccessAlert = false"
        variant="success"
        data-cy="excel-edit-export-success-alert"
        with-icon>
        {{ $t("excelEdit.exportSuccessfull") }}
      </Alert>
      <Alert
        class="w-100"
        with-icon
        :show="vm.showImportSuccessAlert"
        dismissible
        @dismissed="vm.showImportSuccessAlert = false"
        variant="success"
        data-cy="excel-edit-import-success-alert">
        {{ $t("excelEdit.importSuccessfull") }}
      </Alert>
      <Alert class="w-100" with-icon variant="warning" :show="exportWarningsKeys.length > 0">
        <div class="d-flex align-items-center">
          {{ $t("excelEdit.warnings") }} <b-btn size="sm" variant="link" class="ml-1" v-b-modal.warnings-overview> {{ $t("excelEdit.showWarnings") }} </b-btn>
        </div>
      </Alert>
      <b-modal
        header-close-content=""
        id="warnings-overview"
        ok-only
        :ok-title="$t('Close')"
        :title="$t('warningsOverview')"
        body-class="warnings-overview-modal overflow-auto">
        <div v-for="(warningKey, index) in exportWarningsKeys" :key="index">
          <strong>{{ $t(_.camelCase(warningKey)) }}</strong>
          <ul class="warning-entry-container">
            <li class="warning-entry" v-for="(entry, index) in vm.warnings[warningKey]" :key="index">
              {{ $t(`excelEditWarnings.${_.camelCase(entry)}`) }}
            </li>
          </ul>
        </div>
      </b-modal>

      <b-btn variant="primary" @click="triggerExport" data-cy="excel-edit-create-output-btn" :disabled="isTriggerExportDisabled">
        {{ $t("excelEdit.startExport") }}
      </b-btn>
    </div>
    <div class="upload-section">
      <div class="drop-area" @drop.stop.prevent="fileDrop" @dragover.stop.prevent="vm.isDroping = true" @dragleave.stop.prevent="vm.isDroping = false">
        <div class="empty-content" :class="{ 'is-dropping': vm.isDroping }" v-if="!vm.uploadedFile" data-cy="excel-edit-drop-file">
          <div class="is-dropping-content" v-show="vm.isDroping">
            <span class="icon"><i class="cil-cloud-upload"></i></span>
            <span class="text"> {{ $t("dropFileNow") }} </span>
          </div>
          <div v-show="!vm.isDroping">
            <span class="icon"><i class="cil-cloud-upload"></i></span>
            <span class="text">
              {{ $t("excelEdit.dropHint.drop") }} {{ $t("excelEdit.dropHint.orOpen") }}
              <a href="#" class="ml-1 p-0" @click.prevent="fileUploadInput?.click()"> {{ $t("excelEdit.dropHint.fileExplorer") }} </a>
              <input
                ref="fileUploadInput"
                type="file"
                @change="changeFile"
                hidden
                :accept="acceptedMimeType.toString()"
                data-cy="excel-edit-import-upload-txt" />
            </span>
          </div>
        </div>
        <div class="uploaded-content" v-if="vm.uploadedFile">
          <div class="icon">
            <i v-if="hasCorrectFileType" class="mdp-FileExcel"></i>
            <i v-else class="cil-report"></i>
            <span class="name"> {{ vm.uploadedFile.name }} </span>
          </div>
          <div class="action-area mt-2">
            <b-btn class="mr-1" variant="primary" @click="triggerimport" :disabled="!hasCorrectFileType" data-cy="excel-edit-transfer-data">
              {{ $t("excelEdit.startImport") }}
            </b-btn>
            <b-btn @click="vm.uploadedFile = null">
              {{ $t("discardFile") }}
            </b-btn>
          </div>
          <div v-if="vm.uploadedFile && !hasCorrectFileType" class="error-area">
            {{ $t("provideCorrectFile") }}
          </div>
        </div>
      </div>
    </div>
    <export-progress-modal :is-export="vm.isExportProgress" v-model:modal-show="vm.modalShow" :errors="vm.errors" @cancel="cancelExportProgressModal" />
  </div>
  <Spinner v-else />
</template>

<script setup lang="ts">
import { Typeguards } from "@/util/typeguards";
import { AttributeDataTypes } from "@AttributeManager/configurations/AttributeTypeDataTypes";
import Alert from "@common/components/Alert.vue";
import Dropdown from "@common/components/Dropdown.vue";
import Spinner from "@common/components/Spinner.vue";
import { useToast } from "@common/composable/toast";
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { useLicenses } from "@common/composable/useRootStore";
import { ERPSection, ExportSelection, ExportWarnings, Selectable } from "@medapro-types/ContentEditor/Components/ExcelEditEditor";
import { CatalogNodeState } from "@medapro-types/ContentEditor/content-editor-store";
import type { LocalizedLanguage, MAMDetails } from "@medapro-types/common/common";
import { MetaDataState } from "@medapro-types/common/metadata";
import { RootState } from "@medapro-types/common/rootstate";
import { ActivityCriteria, ExcelEditAttributeGroups, ExcelExportArgs } from "@medapro-types/services/excelEdit";
import eventLogger from "@services/ApiLogger/EventLogger.js";
import activityApi from "@services/activity";
import apps from "@services/applications";
import automationServerApi from "@services/automationServer";
import endpoints from "@services/endpoints";
import erpSectionsApi from "@services/erpSections.js";
import excelEditApi from "@services/excelEdit";
import mediaAssetsApi from "@services/mediaAssets.js";
import { BaseIds } from "@util/enums/base-ids";
import { Guid } from "@util/guid";
import { naturalSort } from "@util/naturalSort";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import emitter from "tiny-emitter/instance";
import { Ref, computed, onMounted, reactive, ref, watch, onBeforeUnmount } from "vue";
import { useI18n } from "vue-i18n";
import { createNamespacedHelpers, useState } from "vuex-composition-helpers";
import ExportProgressModal from "./ExportProgressModal.vue";
import { useFiles } from "@common/composable/useFiles";

//#region General
const { t: $t } = useI18n();
const { createToast } = useToast();
const { triggerFileDownloadViaEndpoint } = useFiles();
//#endregion

//#region Store

///contentEditor/catalogNode
const { userSettings, globalParameters } = useState<RootState>(["userSettings", "globalParameters"]);
const { checkForLicensed } = useLicenses();
const { useState: useCatalogNodeState } = createNamespacedHelpers<CatalogNodeState>("contentEditor/catalogNode");
const { path } = useCatalogNodeState(["path"]);

///Metadata
const { useState: useMetaDataState } = createNamespacedHelpers<MetaDataState>("metadata");
const { contentLanguages } = useMetaDataState(["contentLanguages"]);
//#endregion

//#region Computed Store Value
const primaryLanguageCode = computed(() => contentLanguages.value.enabled[0].languageCode);
const { localizedLanguages } = useContentLanguages();

const catalogId = computed<string>(() => {
  return path.value[0].nodeId;
});

const currentNodeId = computed<string>(() => {
  return _.last(path.value).nodeId;
});
const currentNodeName = computed<string>(() => {
  return _.last(path.value).name;
});

//#endregion

//#region ViewModel
type ViewModel = {
  selectedLanguage: string;
  attributeGroups: Array<ExcelEditAttributeGroups>;
  selectedAttributeGroup?: string | null;
  exportSelection: Record<ExportSelection, Selectable>;
  includeUnits: boolean;
  MAMDetails: MAMDetails | undefined;
  uploadedFile: File | null;
  isDroping: boolean;
  isExportProgress: boolean;
  modalShow: boolean;
  warnings: ExportWarnings;
  errors?: string;
  showExportSuccessAlert: boolean;
  showImportSuccessAlert: boolean;
  languages: Array<LocalizedLanguage>;
  exportIsCanceled: boolean;
  abortController: AbortController | null;
  hasUnsavedData: boolean;
};
const vm = reactive<ViewModel>({
  selectedLanguage: primaryLanguageCode.value,
  attributeGroups: [],
  selectedAttributeGroup: null,
  exportSelection: {
    masterData: { name: "MasterData", selected: true },
    alternativeArticleNo: { name: "AlternativeArticleNos", selected: true },
    mediaAssets: { name: "MediaAssets", selected: true },
    keywords: { name: "Keywords", selected: true },
    classification: { name: "Classifications", selected: true },
    references: { name: "References", selected: true },
    prices: { name: "Prices", selected: true },
    globalAttributes: { name: "GlobalAttributes", selected: true },
    erpAttributes: { name: "ErpSections", selected: true },
    textAttributes: { name: "InvariantAttributes", selected: true },
    tableAttributes: { name: "VariantAttributes", selected: true },
    gpsr: { name: "GPSR", selected: true }
  },
  includeUnits: true,
  MAMDetails: undefined,
  isDroping: false,
  uploadedFile: null,
  isExportProgress: true,
  modalShow: false,
  warnings: {},
  errors: undefined,
  showExportSuccessAlert: false,
  showImportSuccessAlert: false,
  languages: [],
  exportIsCanceled: false,
  abortController: null,
  hasUnsavedData: false
});
//#endregion

//#region Language Selection

const languageList = computed(() => {
  return localizedLanguages.value.map((x) => {
    return { key: x.languageCode, name: x.localizedName };
  });
});
//#endregion
const props = defineProps<{ isAdvancedSearchExcelEdit?: boolean; advancedSearchId?: string; advancedSearchName?: string; advancedSearchCatalogId?: string }>();

//#region Attribute Group Selection

const hasMultipleAttributeGroups = computed(() => {
  return _.filter(vm.attributeGroups, (x) => !!x.attributeGroupId)?.length > 1;
});

//#endregion

//#region MAM-Section-Selection
const allMAMSectionsSelected = computed(() => {
  return !_.some(mamSectionSelectionList.value, { selection: false });
});
const noneMAMSectionsSelected = computed(() => {
  return !_.some(mamSectionSelectionList.value, { selection: true });
});
const selectedMAMSectionString = computed(() => {
  if (noneMAMSectionsSelected.value) {
    return `<${$t("none")}>`;
  }
  if (allMAMSectionsSelected.value) {
    return `${$t("all")}`;
  }
  return mamSectionSelectionList.value
    .filter((x) => x.selection)
    .map((x, index) => `${index === 0 ? "" : " "}${x.name}`)
    .toString();
});

const mamSectionsList = ref<Array<string>>([]);
const mamSectionSelectionList = ref<Array<{ name: string; selection: boolean }>>([]);

const selectAllMamSection = () => {
  for (const section of mamSectionSelectionList.value) {
    section.selection = true;
  }
};
const deselectAllMamSection = () => {
  for (const section of mamSectionSelectionList.value) {
    section.selection = false;
  }
};
//#endregion

//#region Erp-Section-Selection
const allERPSectionsSelected = computed(() => {
  return !_.some(erpSectionSelectionList.value, { selection: false, isSelectable: true });
});
const noneERPSectionsSelected = computed(() => {
  return !_.some(erpSectionSelectionList.value, { selection: true });
});

const selectedERPSectionString = computed(() => {
  if (noneERPSectionsSelected.value) {
    return `<${$t("none")}>`;
  }
  if (allERPSectionsSelected.value) {
    return `${$t("all")}`;
  }
  return erpSectionSelectionList.value
    .filter((x) => x.selection)
    .map((x, index) => `${index === 0 ? "" : " "}${x.name}`)
    .toString();
});

const erpSectionsList = ref<Array<Record<string, ERPSection>>>([]);
const erpSectionSelectionList = ref<Array<{ name: string; selection: boolean; id: string; isSelectable: boolean }>>([]);

const selectAllErpSection = () => {
  for (const section of erpSectionSelectionList.value) {
    section.selection = section.isSelectable;
  }
};
const deselectAllErpSection = () => {
  for (const section of erpSectionSelectionList.value) {
    section.selection = false;
  }
};

//#region data export type selection
const exportSelectionPermissions = ref<Record<string, boolean>>();

//#endregion

//#region LifeCycle
onMounted(async () => {
  loadData();
  window.addEventListener("beforeunload", _confirmNavigation);
});
onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", _confirmNavigation);
});
//#endregion

const _confirmNavigation: (e: Event) => boolean | undefined = function (e) {
  if (vm.hasUnsavedData) {
    e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    // Chrome requires returnValue to be set
    return (e.returnValue = "confirm" as unknown as boolean);
  }
};

//#region Export
const isIncludeUnitsEnabled = computed(() => {
  return _.some(
    vm.exportSelection,
    (item) =>
      item.selected &&
      (item.name === "GlobalAttributes" || item.name === "ErpSections" || item.name === "VariantAttributes" || item.name === "InvariantAttributes")
  );
});

const isTriggerExportDisabled = computed(() => {
  return _.filter(vm.exportSelection, (x) => x.selected)?.length == 0 && !vm.includeUnits;
});

const getFileName = () => {
  const formattedToday = moment(new Date()).format("YYYY-MM-DD kk-mm-ss");
  if (props.isAdvancedSearchExcelEdit) {
    return `${formattedToday} ${props.advancedSearchName} ExcelEdit.xlsx`;
  } else {
    const cleanedNodeName = currentNodeName.value.replace(/[!@#$%^&*+\-=[\]{};':"\\|,.<>/?]+/gi, "_");
    return `${formattedToday} ${cleanedNodeName} ExcelEdit.xlsx`;
  }
};

const triggerExport = async () => {
  resetAlerts();
  vm.isExportProgress = true;
  vm.modalShow = true;
  try {
    let excelResponse = null;
    const mamParameters = noneMAMSectionsSelected.value
      ? "None"
      : mamSectionSelectionList.value
          .filter((x) => x.selection)
          .map((x) => x.name)
          .toString();

    vm.exportIsCanceled = false;
    const formData: ExcelExportArgs = {
      catalogId: props.isAdvancedSearchExcelEdit ? (props.advancedSearchCatalogId ?? BaseIds.BaseCatalog) : catalogId.value,
      nodeId: currentNodeId.value ?? Guid.empty,
      attributegroupId: vm.selectedAttributeGroup ?? BaseIds.BaseAttributeGroup,
      language: vm.selectedLanguage ?? primaryLanguageCode.value,
      uiLanguage: userSettings.value.CurrentLocale,
      erpSectionIds: _.chain(erpSectionSelectionList.value)
        .filter((x) => x.selection)
        .map((x) => x.id)
        .value(),
      includeUnits: vm.includeUnits,
      types: _.chain(vm.exportSelection)
        .filter((x) => x.selected)
        .map((x) => x.name)
        .value()
        .toString(),
      mamParameters: vm.MAMDetails?.isMamEnabled ? mamParameters : "None"
    };

    excelResponse = !props.isAdvancedSearchExcelEdit
      ? await excelEditApi.exportExcelEdit(formData)
      : await excelEditApi.exportAdvancedSearchExcelEdit(props.advancedSearchId ?? "", formData);

    vm.warnings = excelResponse.warnings ?? {};
    if (vm.exportIsCanceled) return;

    if (!excelResponse.isSuccess) {
      vm.errors = excelResponse.message;
      return;
    } else {
      triggerFileDownloadViaEndpoint(endpoints.excelEdit.download, {
        token: excelResponse.token,
        fileName: getFileName()
      });
      vm.showExportSuccessAlert = true;
    }
    vm.modalShow = false;
  } catch (error: unknown) {
    if (error && Typeguards.isAxiosError(error)) {
      const responseData = error.response?.data;
      if (responseData) {
        if (hasBackendError409(responseData)) {
          switch (responseData.error.toLocaleLowerCase()) {
            case "invalidnode":
              vm.errors = $t("error.invalidNode").toString();
              break;
            case "invalidcatalog":
              vm.errors = $t("error.invalidCatalog").toString();
              break;
            case "attributegroupnotexist":
              vm.errors = $t("error.attributeGroupNotExist").toString();
              break;
            case "invalidoperation":
              vm.errors = $t("error.invalidOperation").toString();
              break;
            case "noarticleexistsforexport":
              vm.errors = $t("error.noArticleExistsForExport").toString();
              break;
            case "advancedsearchnotexist":
              vm.errors = $t("api.errors.AdvancedSearch.AdvancedSearchNotExist").toString();
              break;
            case "advancedsearchfailed":
              vm.errors = $t("api.errors.AdvancedSearch.AdvancedSearchFailed").toString();
              break;
            case "missingruleparameter":
              vm.errors = $t("api.errors.AdvancedSearch.MissingRuleParameter", responseData.args).toString();
              break;
            case "unknowndatalanguage":
              vm.errors = $t("api.errors.AdvancedSearch.UnknownDataLanguage", responseData.args).toString();
              break;
            case "unexpecteddatalanguage":
              vm.errors = $t("api.errors.AdvancedSearch.UnexpectedDataLanguage", responseData.args).toString();
              break;
            case "unknownattribute":
              vm.errors = $t("api.errors.AdvancedSearch.UnknownAttribute", responseData.args).toString();
              break;
            case "unknownsearchtype":
              vm.errors = $t("api.errors.AdvancedSearch.UnknownSearchType", [$t(`AdvancedSearch.SearchType.${responseData.args}`)]).toString();
              break;
            case "unknownoperatorfordatatype":
              {
                const data = AttributeDataTypes.find((type) => type.key === responseData.args[0]);
                if (data) {
                  responseData.args[0] = $t(data.name);
                }

                vm.errors = $t("api.errors.AdvancedSearch.UnknownOperatorForDataType", responseData.args).toString();
              }
              break;
            case "proceduretimedOut":
              vm.errors = $t("api.errors.AdvancedSearch.ProcedureTimedOut").toString();
              break;
            default:
              vm.modalShow = false;
              emitter.emit("global-error", { type: "api", exception: error });
              break;
          }
        } else {
          vm.modalShow = false;
          emitter.emit("global-error", { type: "api", exception: error });
        }
      } else {
        vm.modalShow = false;
        emitter.emit("global-error", { type: "api", exception: error });
      }
    }
  } finally {
    vm.exportIsCanceled = false;
  }
};

const cancelExportProgressModal = () => {
  if (vm.isExportProgress) {
    vm.exportIsCanceled = true;
  } else if (vm.abortController) {
    vm.abortController.abort(); // Cancel the import request
  }
};

const hasBackendError409 = (e: unknown): e is { message: string; value: string; error: string; args?: any } => {
  return !!e && Object.hasOwn(e, "message") && Object.hasOwn(e, "value") && Object.hasOwn(e, "error");
};

const exportWarningsKeys = computed(() => {
  return Object.keys(vm.warnings);
});

const resetAlerts = () => {
  vm.showExportSuccessAlert = false;
  vm.showImportSuccessAlert = false;
};
//#endregion

//#region File-Upload
const acceptedMimeType = ["application/vnd.ml-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-excel"];

const fileUploadInput: Ref<HTMLInputElement | undefined> = ref();

const hasCorrectFileType = computed(() => {
  return acceptedMimeType.includes(vm.uploadedFile?.type ?? "");
});

const fileDrop = (event: DragEvent) => {
  const data = event.dataTransfer?.files;
  if (data) {
    const file = data.item(0);
    if (file) {
      vm.uploadedFile = file;
    } else {
      alert($t("error.wrongFileType"));
    }
  }
  vm.isDroping = false;
};

const changeFile = (event: Event) => {
  const target: HTMLInputElement | null = <HTMLInputElement>event.target;
  const data = target?.files;
  if (data) {
    const file = data.item(0);
    if (file) {
      vm.uploadedFile = file;
    } else {
      alert($t("error.wrongFileType"));
    }
  }
};

const triggerimport = async () => {
  vm.warnings = {};
  resetAlerts();
  vm.isExportProgress = false;
  vm.modalShow = true;
  try {
    if (vm.uploadedFile) {
      vm.abortController = new AbortController();
      const excelResponse = await excelEditApi.excelImport(vm.uploadedFile, vm.abortController.signal);
      vm.warnings = excelResponse.warnings ?? {};
      const hasWarning: boolean = exportWarningsKeys.value.length > 0;
      createActivity(vm.uploadedFile.name, hasWarning, !excelResponse.isSuccess);
      if (!excelResponse.isSuccess) {
        vm.errors = excelResponse.message;
        return;
      } else {
        vm.showImportSuccessAlert = true;
        emitter.emit("refresh-catalog-tree");
        if (checkForLicensed("AutomationServer")) {
          try {
            await automationServerApi.executeAutomationsIfRequired([3, 5]); // triggertypes ArticlesModified and DataImported
          } catch (error) {
            console.error("Automation execution for the trigger type 'Articles modified and Data imported' failed with error : ", error);
          }
        }

        setTimeout(() => {
          vm.modalShow = false;
        }, 1000);
      }
    }
  } catch (error: any) {
    if (Typeguards.isAxiosError(error)) {
      if (axios.isCancel(error)) {
        eventLogger.info("ImportCancelled", "ExcelEdit import cancelled by user.");
        return;
      }

      const status = error.response?.status;

      if (status === 400) {
        const fileErrors = error.response?.data?.file;
        const errorKey = fileErrors?.[0];

        const errorMessage = errorKey ? $t("api.errors." + errorKey) : $t("UploadFailed");

        createToast({
          text: errorMessage,
          title: $t("Error"),
          variant: "danger",
          titleIcon: "Content-Editor",
          textIllustration: "Error",
          statusTextIcon: "XCircleSolid"
        });
      } else {
        const responseData = error.response?.data;

        if (responseData) {
          if (hasBackendError409(responseData)) {
            vm.errors = responseData.message;
          } else {
            vm.modalShow = false;
            emitter.emit("global-error", { type: "api", exception: error });
          }
        } else {
          vm.modalShow = false;
          emitter.emit("global-error", { type: "api", exception: error });
        }
      }
    }
  } finally {
    vm.uploadedFile = null;
  }
};
const createActivity = async (fileName: string, hasWarning: boolean, hasError: boolean) => {
  try {
    if (globalParameters.value.IsActivityFeedEnabled) {
      const criteria: ActivityCriteria = {
        severity: hasError ? "Error" : hasWarning ? "Warning" : "Information",
        process: "Import",
        objectType: "Data",
        objectValue: fileName,
        status: hasError ? "WithAtLeastOneError" : hasWarning ? "WithAtLeastOneWarning" : "Successful",
        action: hasError ? "Canceled" : hasWarning ? "Completed" : "Completed",
        applicationId: Number(apps.Modules.ContentEditor.Id),
        descriptionKey: "ExcelEditExecuted",
        descriptionValues: []
      };
      const criterias: Array<ActivityCriteria> = [criteria];
      await activityApi.createActivity(criterias);
    }
  } catch (error) {
    console.error("Activity insertion for excel edit import process failed with error : ", error);
  }
};
//#endregion

//#region Load Data
const loadData = async () => {
  try {
    await loadLanguageSpecificData();
    await loadExportSelectionTypes();
    vm.MAMDetails = await mediaAssetsApi.getMamDetails();
    if (vm.MAMDetails?.isMamEnabled) {
      mamSectionsList.value = await excelEditApi.getMamParameterTypes();

      if (userSettings.value?.ExcelEditAreas) {
        const savedMamSectionNames = JSON.parse(userSettings.value?.ExcelEditAreas)?.selectedMAMSections ?? [];
        mamSectionSelectionList.value = mamSectionsList.value
          .filter((x) => x != "None")
          .map((x) => {
            return { selection: savedMamSectionNames.includes(x), name: x };
          });
      }
    }
  } catch (error: unknown) {
    if (Typeguards.isAxiosError(error)) {
      console.error("During the Fetching of the Data occured an Error", error.message);
    }
  }
};

const loadLanguageSpecificData = async () => {
  try {
    if (props.isAdvancedSearchExcelEdit && props.advancedSearchCatalogId && props.advancedSearchId) {
      vm.attributeGroups = await excelEditApi.getAttributeGroupsOfAdvancedSearch(
        props.advancedSearchCatalogId,
        props.advancedSearchId,
        primaryLanguageCode.value
      );
    } else {
      vm.attributeGroups = await excelEditApi.getAttributeGroupsOfCatalogNode(catalogId.value, currentNodeId.value, primaryLanguageCode.value);
    }

    vm.selectedAttributeGroup = hasMultipleAttributeGroups.value ? null : vm.attributeGroups[0].attributeGroupId;
    vm.attributeGroups = naturalSort(vm.attributeGroups, "attributeGroupPath");
    vm.attributeGroups.unshift({
      attributeGroupId: null,
      attributeGroupPath: `<${$t("none")}>`
    });

    erpSectionsList.value = await erpSectionsApi.get([primaryLanguageCode.value]);
    if (userSettings.value?.ExcelEditAreas) {
      const savedErpIds = JSON.parse(userSettings.value.ExcelEditAreas)?.selectedErpSections ?? [];

      erpSectionSelectionList.value = erpSectionsList.value.map((x) => {
        return {
          name: x[primaryLanguageCode.value].name,
          id: x[primaryLanguageCode.value].erpSectionId,
          isSelectable: !(x[primaryLanguageCode.value].isReadOnly && globalParameters.value.IsErpActivated),
          selection:
            !(x[primaryLanguageCode.value].isReadOnly && globalParameters.value.IsErpActivated) &&
            savedErpIds.includes(x[primaryLanguageCode.value].erpSectionId)
        };
      });
    }
  } catch (error: unknown) {
    if (Typeguards.isAxiosError(error)) {
      console.error("During the Fetching of the Data occured an Error", error.message);
    }
  }
};

const loadExportSelectionTypes = async () => {
  try {
    const exportTypes: Record<string, boolean> = await excelEditApi.getExportDataTypes();
    exportSelectionPermissions.value = exportTypes;
    if (!exportTypes["References"]) {
      vm.exportSelection.references.selected = false;
    }
    if (!exportTypes["Prices"]) {
      vm.exportSelection.prices.selected = false;
    }
  } catch (error: unknown) {
    if (Typeguards.isAxiosError(error)) {
      console.error("During the Fetching of the Data occured an Error", error.message);
    }
  }
};

//#region save and restore user settings
const getExcelEditAreasToSave = () => {
  if (!vm.hasUnsavedData) return;
  const currentExcelEditAreas = userSettings.value.ExcelEditAreas ? JSON.parse(userSettings.value.ExcelEditAreas) : {};
  const state = {
    exportSelection: Object.fromEntries(Object.entries(vm.exportSelection).map(([key, value]) => [key, value.selected])),
    includeUnits: vm.includeUnits,
    selectedErpSections:
      erpSectionSelectionList.value.length > 0
        ? erpSectionSelectionList.value.filter((x) => x.selection).map((x) => x.id)
        : (currentExcelEditAreas.selectedErpSections ?? []),
    selectedMAMSections:
      mamSectionSelectionList.value.length > 0
        ? mamSectionSelectionList.value.filter((x) => x.selection).map((x) => x.name)
        : (currentExcelEditAreas.selectedMAMSections ?? [])
  };

  return state;
};

const restoreExcelEditAreasFromSettings = () => {
  if (!userSettings.value?.ExcelEditAreas) return;

  const parsed = JSON.parse(userSettings.value.ExcelEditAreas);
  if (parsed.exportSelection) {
    Object.entries(vm.exportSelection).forEach(([key, value]) => {
      if (parsed.exportSelection[key] !== undefined) {
        value.selected = parsed.exportSelection[key];
      }
    });
  }

  if (typeof parsed.includeUnits === "boolean") {
    vm.includeUnits = parsed.includeUnits;
  }
};
//#endregion

//#region Watchers
watch(
  () => userSettings.value,
  async (nv) => {
    if (nv) {
      restoreExcelEditAreasFromSettings();
    }
  },
  { immediate: true }
);

watch(
  () => vm.exportSelection,
  () => {
    vm.hasUnsavedData = true;
    if (!isIncludeUnitsEnabled.value) {
      vm.includeUnits = false;
    }
  },
  { deep: true }
);

watch(
  () => [vm.includeUnits, erpSectionSelectionList.value.map((x) => x.selection), mamSectionSelectionList.value.map((x) => x.selection)],
  () => {
    vm.hasUnsavedData = true;
  }
);

watch(
  () => vm.modalShow,
  () => {
    vm.errors = undefined;
  }
);

watch(
  () => userSettings.value.CurrentLocale,
  () => {
    loadLanguageSpecificData();
  }
);

defineExpose({ getExcelEditAreasToSave });
//#endregion
</script>
